import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPiwigoComponent } from './simple-icons-piwigo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPiwigoComponent ],
    exports:      [ SimpleIconsPiwigoComponent ],
    bootstrap:    []
})
export class SimpleIconsPiwigoModule {}
